export default __webpack_public_path__ + "static/anastasia-c02985b6da83d79b7a33acbae0bcbb9e.webp";